import React from "react";
import { Square1Style } from "./css/Square1Style";
import TemplateImage from "../../components/editor/Templates/TemplateImage";
import TemplateLogo from "../../components/editor/Templates/TemplateLogo";
import TemplateWatermark from "../../components/editor/Templates/TemplateWatermark";
import TemplateText from "../../components/editor/Templates/TemplateText";
const square_1_1 = (props) => {
  return (
    <Square1Style>
      <div className="template-wrapper">
        <div className="poster one-by-one">
          <TemplateLogo logo={props.logo} />
          <TemplateWatermark watermark={props.watermark} />
          <div className="bg one">
            <TemplateImage slideType={props.slideType} file={props.file} />
          </div>
          <div className="poster-content one">
            <div className="text-wrapper flex-column">
              <TemplateText
                id={props.id}
                text={props.text}
                textStyle={props.textStyle}
                editStatus={props.editStatus}
                onInputSlideText={props.onInputSlideText}
              />
            </div>
          </div>
        </div>
      </div>
    </Square1Style>
  );
};

export default square_1_1;
